module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/88727f206ee026a526b87535e352da55.png";